module.exports = __webpack_public_path__ + "static/img/rating-B.e3c6566.png";